import { useStateManager } from "@bcm-dev/bcms-vite";
import { TableBody, TableColumnContainer, TableColumnView, TableView } from "components/shared";
import React from "react";
import ImportFileMappingPreviewTableRow from "../ImportFileMappingPreviewTableRow";

import "./styles.css";

/**
 * @function ImportFileMappingPreviewTable
 * @return {React.Component}
 * @exported true
 * @description The Import File Mapping Preview table for the ImportFileMappingPreviewWidget.
 */
export default function ImportFileMappingPreviewTable(props) {
    const { data } = useStateManager();
    const columns = data.selectedColumns;
    const participants = data.achToParticipants.participants;
    const columnsItems = columns.map(item => {
        const optionName = item.value.value.replace("(Required)","");
        
        return <TableColumnView key={item.id} className={`column-item ${item.value.class}`} text={`${optionName}`} />
    }, []);
    const participantItems = participants.map(item => <ImportFileMappingPreviewTableRow key={item.id} dataPoint={ `Mapping_Preview_Row_Account_Number_Label_${ item.id }` } data={item} />, []);

    return (
        <TableView className="import-file-mapping-preview-table">
            <TableColumnContainer>
                {columnsItems}
            </TableColumnContainer>
            <TableBody>
                {participantItems}
            </TableBody>
        </TableView>
    )
}
